import { render, staticRenderFns } from "./TheMultiModalMedico.vue?vue&type=template&id=6cec3c8c&scoped=true&"
import script from "./TheMultiModalMedico.vue?vue&type=script&lang=js&"
export * from "./TheMultiModalMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec3c8c",
  null
  
)

export default component.exports